export type SpreadsheetColumns<T extends Record<string, unknown>> =
  (keyof T extends string ? keyof T : never)[];

export interface SaveSpreadsheetOptions<T extends Record<string, unknown>> {
  /**
   * The format to save. "csv" will save as CSV, while "xlsx" will save as an Excel file
   */
  format: 'csv' | 'xlsx';
  /**
   * Name of the file that will be saved. Should not include the file extension
   */
  basename: string;
  /**
   * Ensures that, even if properties are omitted in the data (such as optional properties), the columns are consistent
   */
  columns?: SpreadsheetColumns<Partial<T>>;
  data: Partial<T>[];
}

export async function saveSpreadsheet<T extends Record<string, unknown>>({
  format,
  data,
  basename,
  columns,
}: SaveSpreadsheetOptions<T>) {
  const XLSX = await import('xlsx');

  const worksheet = XLSX.utils.json_to_sheet(data, { header: columns });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  if (format === 'csv') {
    XLSX.writeFile(workbook, `${basename}.csv`, {
      bookType: 'csv',
    });
  } else {
    XLSX.writeFile(workbook, `${basename}.xlsx`, {
      bookType: 'xlsx',
    });
  }
}
